class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    const closeBtn =
      this.querySelector('.ss-search__close') ||
      this.querySelector('.modal__close-button');
    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      event.target.classList.contains('modal-overlay') ||
      event.target.hasAttribute('data-ss-search-overlay') ||
      event.target.classList.contains('ss-search__overlay')
    ) {
      this.close(false);
    }
  }

  lockScroll() {
    if (document.body.dataset.ssSearchScrollLocked === '1') return;
    document.body.dataset.ssSearchScrollLocked = '1';
    document.body.classList.add('overflow-hidden', 'ss-search-open');
    document.documentElement.classList.add('ss-header-above-search');
  }

  unlockScroll() {
    if (document.body.dataset.ssSearchScrollLocked !== '1') return;
    delete document.body.dataset.ssSearchScrollLocked;
    document.body.classList.remove('overflow-hidden', 'ss-search-open');
    document.documentElement.classList.remove('ss-header-above-search');
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = event.target && event.target.closest ? event.target.closest('details') : this.detailsContainer;
    if (!details) return;
    details.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden', 'ss-search-open');
    this.lockScroll();

    if (window.ssHeaderUI && typeof window.ssHeaderUI.closeAll === 'function') {
      window.ssHeaderUI.closeAll({ search: true, searchEl: this.detailsContainer });
    }

    const trapRoot = this.detailsContainer.querySelector('[tabindex="-1"]');
    const trapInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (trapRoot) trapFocus(trapRoot, trapInput || trapRoot);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'ss-search-open');
    document.documentElement.classList.remove('ss-header-above-search');
    this.unlockScroll();
  }
}

customElements.define('details-modal', DetailsModal);
